
export default {
  props: { item: { default: {} }, noRemove: {} },
  data() {
    return {};
  },
  mounted() {
    this.$hyperItem.inFavorites(this.item);
  },
  methods: {},
};
